import { ImSpinner6 } from 'react-icons/im';

interface SpinProps {
  colorStyle?: string;
}

const Spin = ({ colorStyle = 'text-primary' }: SpinProps) => {
  return (
    <div className="w-full text-center flex justify-center">
      <ImSpinner6 className={`animate-spin text-5xl ${colorStyle}`} />
    </div>
  );
};

export default Spin;
